/* hdr-keuzehulp.js: de keuzehulp "Welk dakraam past bij jou?" (sections/hdr-keuzehulp.liquid).

   WAT HIJ DOET
   Leest de gegenereerde data uit <script id="hdr-situatiewijzer-data"> (snippets/
   hdr-situatiewijzer-data.liquid, bron content/situatiewijzer/beslistabel.json via
   tools/generate_content/build_situatiewijzer.py) en speelt de vragen af: een vraag per scherm,
   Vorige, Opnieuw beginnen, en aan het eind het advies uit data.resultaten[data.paden[sleutel]].
   De sleutel is "V1=nieuw|V2=schuin|...": de generator heeft elk pad vooraf doorgerekend, dus hier
   staat geen beslislogica. Zo kan de site nooit iets anders adviseren dan de getoetste tabel.

   GRENZEN (spec 2026-10-14, sectie 5 en 6)
   - Geen innerHTML of insertAdjacentHTML: elke tekst gaat via textContent, elk element via
     createElement. Een href komt alleen uit de data en moet met "/" of "#" beginnen, zonder
     backslash, stuurteken of witruimte (veiligeUrl).
   - Niets in localStorage, sessionStorage of cookies: verversen begint opnieuw.
   - Events via window.hdrTrack, pas opgezocht op het moment van versturen (de E2E kan hem na het
     laden omwikkelen). Met ?keuzehulp_test=1 gaat er geen keuzehulp-event weg.
   - De chatknop opent de bestaande webchat zonder context, alleen als die knop er is en dicht staat,
     en nooit bij een resultaat met chat: false (de drie platdak-uitkomsten, @29c79a). */
(function () {
  'use strict';

  var root = document.querySelector('[data-hdr-kh]');
  var bron = document.getElementById('hdr-situatiewijzer-data');
  if (!root || !bron) return;
  var app = document.getElementById('hdr-kh-app');
  var scherm = document.getElementById('hdr-kh-scherm');
  var live = document.getElementById('hdr-kh-live');
  if (!app || !scherm || !live) return;

  var data;
  try {
    data = JSON.parse(bron.textContent);
  } catch (e) {
    return; // zonder geldige data blijft alleen de statische tekstversie staan
  }
  if (!data || !data.vragen || !data.paden || !data.resultaten || !data.teksten || !data.vragen[data.start]) return;

  var T = data.teksten;
  var params = new URLSearchParams(window.location.search);
  var TEST = params.get('keuzehulp_test') === '1';
  var INGANGEN = ['artikel', 'collectie', 'menu'];
  var ingang = INGANGEN.indexOf(params.get('ingang')) === -1 ? 'pagina' : params.get('ingang');
  var TERUGVAL = 'Voor deze combinatie hebben we geen vast advies.';
  var TERUGVAL_LINK = 'Bekijk welk dakraam bij welke situatie past';

  var antwoorden = []; // [{vraag, antwoord}], in volgorde
  // vraag -> eerder gekozen antwoord. Blijft staan na Vorige, zodat de vraag laat zien wat de bezoeker
  // koos (aria-pressed plus een markering). Wordt leeg bij Opnieuw beginnen en zodra een eerdere
  // vraag een ander antwoord krijgt, want dan zijn de latere antwoorden niet meer van toepassing.
  var gekozen = {};
  // Het plan van de laatst verstuurde keuzehulp_started, of null zolang deze doorloop nog geen start
  // heeft. Een wissel tussen vervangen en de kern (nieuw of orienteer) via Vorige is een nieuwe
  // doorloop: opnieuw started, en geteld weer leeg (Ruling 40, spec sectie 5).
  var startPlan = null;
  var geteld = false;  // al een keuzehulp_to_collection met telt "ja" in deze doorloop
  var resultaat = null; // het getoonde resultaat, of null

  function stuur(naam, p) {
    if (TEST) return;
    if (typeof window.hdrTrack !== 'function') return;
    try {
      window.hdrTrack(naam, p);
    } catch (e) {
      /* meten mag de keuzehulp nooit breken */
    }
  }

  function el(tag, klasse, tekst) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (tekst !== undefined && tekst !== null) e.textContent = tekst;
    return e;
  }

  // Alleen een pad op deze winkel of een anker. Een browser leest een backslash als een slash, dus
  // een slash gevolgd door een backslash en een hostnaam net zo goed naar een andere site wijst als twee slashes.
  // Een browser haalt ook een tab of regeleinde uit een URL, dus "/\t/voorbeeld.nl" wordt "//voorbeeld.nl":
  // daarom geen enkel stuurteken en geen witruimte, waar ook in de URL.
  var STUURTEKEN_OF_WIT = /[\u0000-\u001F\u007F\s]/;
  function veiligeUrl(url) {
    return typeof url === 'string' && (url.charAt(0) === '/' || url.charAt(0) === '#') &&
      url.indexOf('//') !== 0 && url.indexOf('\\') === -1 && !STUURTEKEN_OF_WIT.test(url);
  }

  function link(klasse, tekst, url, positie) {
    if (!veiligeUrl(url)) return el('span', klasse, tekst);
    var a = el('a', klasse, tekst);
    a.href = url;
    if (positie) a.setAttribute('data-kh-positie', positie);
    return a;
  }

  function actieknop(klasse, actie, tekst) {
    var b = el('button', klasse, tekst);
    b.type = 'button';
    b.setAttribute('data-kh-actie', actie);
    return b;
  }

  function optie(vraagId, antwoordId) {
    var v = data.vragen[vraagId];
    if (!v) return null;
    for (var i = 0; i < v.opties.length; i++) {
      if (v.opties[i].id === antwoordId) return v.opties[i];
    }
    return null;
  }

  function sleutel() {
    return antwoorden.map(function (a) { return a.vraag + '=' + a.antwoord; }).join('|');
  }

  function volgendeVraag() {
    if (!antwoorden.length) return data.start;
    var laatst = antwoorden[antwoorden.length - 1];
    var o = optie(laatst.vraag, laatst.antwoord);
    return o && o.volgende && data.vragen[o.volgende] ? o.volgende : null;
  }

  function chatknop() {
    return document.querySelector('.hdr-chat__knop[data-action="open-chat"]');
  }

  function aankondigen(tekst, kop, naInteractie) {
    if (!naInteractie) return; // bij het laden geen focussprong en geen voorleestekst
    live.textContent = tekst;
    kop.focus();
  }

  function balk(metVoortgang, n) {
    var b = el('div', 'hdr-kh__balk');
    if (antwoorden.length) b.appendChild(actieknop('hdr-kh__vorige', 'vorige', T.vorige));
    if (metVoortgang) {
      var p = el('p', 'hdr-kh__voortgang', T.voortgang.replace('{n}', String(n)));
      p.id = 'hdr-kh-voortgang';
      b.appendChild(p);
    }
    return b;
  }

  function kop(tekst) {
    var h = el('h2', 'hdr-kh__kop h3', tekst);
    h.id = 'hdr-kh-kop';
    h.tabIndex = -1;
    return h;
  }

  function toon(naInteractie) {
    scherm.textContent = '';
    var vraag = volgendeVraag();
    if (vraag) toonVraag(vraag, naInteractie);
    else toonResultaat(naInteractie);
  }

  function toonVraag(id, naInteractie) {
    var v = data.vragen[id];
    var n = antwoorden.length + 1;
    resultaat = null;
    root.setAttribute('data-kh-stap', id);
    root.removeAttribute('data-kh-uitkomst');

    scherm.appendChild(balk(true, n));
    if (id === data.start && T.inleiding) scherm.appendChild(el('p', 'hdr-kh__inleiding', T.inleiding));
    var h = kop(v.vraag);
    scherm.appendChild(h);

    var groep = el('div', 'hdr-kh__opties');
    groep.setAttribute('role', 'group');
    groep.setAttribute('aria-labelledby', 'hdr-kh-kop');
    if (v.hint) {
      var hint = el('p', 'hdr-kh__hint', v.hint);
      hint.id = 'hdr-kh-hint';
      scherm.appendChild(hint);
      groep.setAttribute('aria-describedby', 'hdr-kh-hint');
    }
    v.opties.forEach(function (o) {
      var b = el('button', 'hdr-kh__optie');
      b.type = 'button';
      b.setAttribute('data-kh-vraag', id);
      b.setAttribute('data-kh-antwoord', o.id);
      if (Object.prototype.hasOwnProperty.call(gekozen, id)) {
        b.setAttribute('aria-pressed', gekozen[id] === o.id ? 'true' : 'false');
      }
      b.appendChild(el('span', 'hdr-kh__optie-label', o.label));
      if (o.hint) b.appendChild(el('span', 'hdr-kh__optie-hint', o.hint));
      groep.appendChild(b);
    });
    scherm.appendChild(groep);

    if (antwoorden.length) {
      var acties = el('div', 'hdr-kh__acties');
      acties.appendChild(actieknop('hdr-kh__opnieuw', 'opnieuw', T.opnieuw));
      scherm.appendChild(acties);
    }
    aankondigen(T.voortgang.replace('{n}', String(n)) + '. ' + v.vraag, h, naInteractie);
  }

  function toonTerugval(naInteractie) {
    resultaat = null;
    root.setAttribute('data-kh-stap', 'terugval');
    root.removeAttribute('data-kh-uitkomst');
    scherm.appendChild(balk(false, 0));
    var h = kop(TERUGVAL);
    scherm.appendChild(h);
    var p = el('p', 'hdr-kh__reden');
    p.appendChild(link('hdr-kh__link', TERUGVAL_LINK, '#hdr-kh-statisch-kop', null));
    scherm.appendChild(p);
    var acties = el('div', 'hdr-kh__acties');
    acties.appendChild(actieknop('hdr-kh__opnieuw', 'opnieuw', T.opnieuw));
    scherm.appendChild(acties);
    aankondigen(TERUGVAL, h, naInteractie);
  }

  function vervangZin(zin) {
    var p = el('p', 'hdr-kh__vervang');
    var i = zin.indexOf('Maatwijzer');
    if (i === -1) {
      p.textContent = zin;
      return p;
    }
    p.appendChild(document.createTextNode(zin.slice(0, i)));
    p.appendChild(link('hdr-kh__link', 'Maatwijzer', '/pages/maatwijzer', 'aanvuller'));
    p.appendChild(document.createTextNode(zin.slice(i + 'Maatwijzer'.length)));
    return p;
  }

  function toonResultaat(naInteractie) {
    var index = data.paden[sleutel()];
    var res = typeof index === 'number' ? data.resultaten[index] : null;
    if (!res) {
      toonTerugval(naInteractie);
      return;
    }
    resultaat = res;
    root.setAttribute('data-kh-stap', 'resultaat');
    root.setAttribute('data-kh-uitkomst', res.uitkomst);

    scherm.appendChild(balk(false, 0));
    var h = kop(res.kop);
    h.className = 'hdr-kh__kop hdr-kh__kop--advies h2';
    scherm.appendChild(h);
    if (res.reden) scherm.appendChild(el('p', 'hdr-kh__reden', res.reden));
    (res.uitleg || []).forEach(function (zin) {
      scherm.appendChild(el('p', 'hdr-kh__uitleg', zin));
    });
    if (res.knop) scherm.appendChild(link('button hdr-kh__knop', res.knop.tekst, res.knop.url, 'advies'));

    if (res.alternatieven && res.alternatieven.length) {
      var alt = el('div', 'hdr-kh__blok');
      alt.appendChild(el('h3', 'hdr-kh__blokkop h4', T.alternatieven_kop));
      var lijst = el('ul', 'hdr-kh__alternatieven');
      res.alternatieven.forEach(function (a) {
        var li = el('li', 'hdr-kh__alt');
        var titel = el('p', 'hdr-kh__alt-kop');
        titel.appendChild(link('hdr-kh__alt-link', a.kop, a.url, 'alternatief'));
        li.appendChild(titel);
        if (a.reden) li.appendChild(el('p', 'hdr-kh__alt-reden', a.reden));
        if (a.helling) li.appendChild(el('p', 'hdr-kh__alt-helling', a.helling));
        lijst.appendChild(li);
      });
      alt.appendChild(lijst);
      scherm.appendChild(alt);
    }

    var aanvullers = res.aanvullers || [];
    if (res.helling || aanvullers.length || res.vervang_zin) {
      var weet = el('div', 'hdr-kh__blok');
      weet.appendChild(el('h3', 'hdr-kh__blokkop h4', T.aanvullers_kop));
      var ul = el('ul', 'hdr-kh__aanvullers');
      if (res.helling) ul.appendChild(el('li', 'hdr-kh__aanvuller hdr-kh__helling', res.helling));
      aanvullers.forEach(function (av) {
        var li = el('li', 'hdr-kh__aanvuller');
        li.setAttribute('data-kh-aanvuller', av.id);
        li.appendChild(el('span', 'hdr-kh__aanvuller-tekst', av.tekst));
        (av.links || []).forEach(function (l) {
          li.appendChild(document.createTextNode(' '));
          li.appendChild(link('hdr-kh__link', l.tekst, l.url, 'aanvuller'));
        });
        ul.appendChild(li);
      });
      if (res.vervang_zin) {
        var lv = el('li', 'hdr-kh__aanvuller');
        lv.appendChild(vervangZin(res.vervang_zin));
        ul.appendChild(lv);
      }
      weet.appendChild(ul);
      scherm.appendChild(weet);
    }

    var acties = el('div', 'hdr-kh__acties');
    acties.appendChild(actieknop('hdr-kh__opnieuw', 'opnieuw', T.opnieuw));
    if (res.chat === true && chatknop()) {
      acties.appendChild(actieknop('button button--secondary hdr-kh__chat', 'chat', T.chat));
    }
    scherm.appendChild(acties);

    stuur('keuzehulp_completed', { uitkomst: res.uitkomst });
    aankondigen(res.kop, h, naInteractie);
  }

  // Vervangen is een eigen soort start; nieuw en orienteer zijn samen de kern.
  function soort(plan) {
    return plan === 'vervang' ? 'vervang' : 'kern';
  }

  function kies(vraag, antwoord) {
    if (!optie(vraag, antwoord) || vraag !== volgendeVraag()) return;
    if (vraag === data.start) {
      if (startPlan === null) {
        startPlan = antwoord;
        stuur('keuzehulp_started', { ingang: ingang, plan: antwoord });
      } else if (soort(antwoord) !== soort(startPlan)) {
        // Via Vorige van vervangen naar de kern of terug: een nieuwe doorloop.
        startPlan = antwoord;
        geteld = false;
        stuur('keuzehulp_started', { ingang: ingang, plan: antwoord });
      }
      // Dezelfde soort (hetzelfde antwoord, of nieuw en orienteer onderling): geen started, geteld blijft.
    }
    stuur('keuzehulp_answer', { vraag: vraag, antwoord: antwoord });
    antwoorden.push({ vraag: vraag, antwoord: antwoord });
    // Hetzelfde antwoord geeft dezelfde vervolgvragen, dus hun eerdere keuze blijft gemarkeerd;
    // een ander antwoord wist alles na deze vraag.
    if (gekozen[vraag] !== antwoord) {
      gekozen = {};
      antwoorden.forEach(function (a) { gekozen[a.vraag] = a.antwoord; });
    }
    toon(true);
  }

  function openChat() {
    var knop = chatknop();
    if (!knop || knop.getAttribute('aria-expanded') === 'true') return;
    var oud = knop.getAttribute('data-chat-ingang');
    knop.setAttribute('data-chat-ingang', 'keuzehulp');
    knop.click();
    if (oud === null) knop.removeAttribute('data-chat-ingang');
    else knop.setAttribute('data-chat-ingang', oud);
  }

  function linkKlik(a) {
    var positie = a.getAttribute('data-kh-positie');
    if (!positie || !resultaat) return;
    var telt = 'nee';
    if (positie !== 'aanvuller' && resultaat.telt === true && !geteld) {
      telt = 'ja';
      geteld = true;
    }
    stuur('keuzehulp_to_collection', { uitkomst: resultaat.uitkomst, positie: positie, telt: telt });
  }

  scherm.addEventListener('click', function (e) {
    var doel = e.target && e.target.closest ? e.target.closest('button, a') : null;
    if (!doel || !scherm.contains(doel)) return;
    if (doel.tagName === 'A') {
      linkKlik(doel);
      return;
    }
    if (doel.hasAttribute('data-kh-antwoord')) {
      kies(doel.getAttribute('data-kh-vraag'), doel.getAttribute('data-kh-antwoord'));
      return;
    }
    var actie = doel.getAttribute('data-kh-actie');
    if (actie === 'vorige' && antwoorden.length) {
      antwoorden.pop();
      toon(true);
    } else if (actie === 'opnieuw') {
      antwoorden = [];
      gekozen = {};
      startPlan = null;
      geteld = false;
      toon(true);
    } else if (actie === 'chat') {
      openChat();
    }
  });

  // Middelklik opent een link in een nieuw tabblad zonder click-event; die telt ook als doorklik.
  scherm.addEventListener('auxclick', function (e) {
    if (e.button !== 1) return;
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (a && scherm.contains(a)) linkKlik(a);
  });

  // De kop krijgt na elke stap focus via script. Niet elke browser telt dat als :focus-visible, dus
  // houdt de root bij of de laatste invoer van het toetsenbord kwam; de CSS toont dan altijd de ring.
  // Een keydown zonder key (bijvoorbeeld van autofill) mag hier niet stuklopen.
  document.addEventListener('keydown', function (e) {
    var k = e.key || '';
    if (k === 'Tab' || k === 'Enter' || k === ' ' || k.indexOf('Arrow') === 0) {
      root.setAttribute('data-kh-toets', '');
    }
  }, true);
  document.addEventListener('pointerdown', function () {
    root.removeAttribute('data-kh-toets');
  }, true);

  app.hidden = false;
  toon(false);
})();
